<template>
  <column-chart :data="chart_data" :options="chart_options" />
</template>

<script>
  import { green, red, yellow, purple, crimson } from '@shared/helpers/css';
  import { mapGetters } from 'vuex';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import ColumnChart from '@shared/components/stats-chart-column';

  export default {
    components: {
      ColumnChart
    },
    computed: {
      ...mapGetters('pbx/stats/general/table', { items: DATA }),
      columns() {
        return [
          this.$t('pbx.stat.type_answer.ANSWERED'),
          this.$t('pbx.stat.type_answer.NO_ANSWER'),
          this.$t('pbx.stat.type_answer.CANCELED'),
          this.$t('pbx.stat.type_answer.REJECTED'),
          this.$t('pbx.stat.type_answer.FAILED')
        ];
      },
      chart_data() {
        const g = this.items.map(i => [
          i['group'],
          i['answered'],
          i['no_answer'],
          i['canceled'],
          i['rejected'],
          i['failed']
        ]);
        return [['', ...this.columns], ...g];
      },
      chart_options() {
        return {
          chartArea: { width: '80%', height: '60%', top: '15', bottom: '125' },
          series: {
            0: { color: green },
            1: { color: yellow },
            2: { color: crimson },
            3: { color: purple },
            4: { color: red }
          }
        };
      }
    }
  };
</script>
